export default __webpack_public_path__ + "static/media/decor.1c27f862.jpg";